import common from './common';

export default {
  ...common.button,
  color: `gray700`,
  '::before': {
    ...common.button['::before'],
    bg: `white`,
  },
  '::after': {
    ...common.button['::after'],
    bg: `white`,
    borderColor: 'transparent',
    borderWidth: '3px',
    outlineWidth: '1px',
    outlineColor: 'gray300',
    outlineStyle: 'solid',
    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  },
  ':hover': {
    '::after': {
      bg: `gray050`,
      outlineColor: 'gray300',
    },
  },
  ':active': {
    '::after': {
      bg: `gray050`,
      outlineColor: 'gray300',
      boxShadow:
        '0px 0px 0px 4px #EEF2F6, 0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
    },
  },
};
